/**
 * @desc 修改备注
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationMaster.updateRemark.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/updateRemark`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
